(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.querySelectorAll('.toggle-btn').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const submenu = this.closest('li').querySelector('.submenu');
      const iconPlus = this.querySelector('.icon-plus');
      const iconMinus = this.querySelector('.icon-minus');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        submenu.style.maxHeight = '0';
        iconPlus.style.display = 'inline';
        iconMinus.style.display = 'none';
        this.setAttribute('aria-expanded', 'false');
      } else {
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
        iconPlus.style.display = 'none';
        iconMinus.style.display = 'inline';
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
